import { Community } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCommunity12Line = createIcon(Community, 12, "Line");
export const IconCommunity16Line = createIcon(Community, 16, "Line");
export const IconCommunity20Line = createIcon(Community, 20, "Line");
export const IconCommunity24Line = createIcon(Community, 24, "Line");
export const IconCommunity32Line = createIcon(Community, 32, "Line");
export const IconCommunity48Line = createIcon(Community, 48, "Line");
export const IconCommunity64Line = createIcon(Community, 64, "Line");
